import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation } from "@tanstack/react-query";

export const useResetPassword = (onSuccess) => {
  const mutationFn = useApiRequest({
    url: "auth/password",
    method: HttpMethod.Post,
    unversioned: true,
  });

  return useMutation({
    mutationKey: ["reset-password"],
    mutationFn,
    onSuccess: () => onSuccess?.(),
  });
};
